import { DtoBase } from '../../../shared/model/index';

export class EventItemCustomFieldAvailValueCreditType extends DtoBase {
  public Id: number = 0;
  public EventCustomRegFieldAvailValuesId: number = 0;
  public CeCreditTypeId: number = 0;
  public Credits: number = 0;
  public IrsProgramNumber: string = '';
}
